//"descripcion":"descripcion", 
//"codigoIso":"codigoIso", 
//"estatusId":"estatusId", 
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PaisForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Pais"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.codigoIso}>            
                              <label  >{strings?strings["codigoIso"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["codigoIso"]:""} 
                                    name="codigoIso"
                                    onChange={onChange}
                                    value={datos.codigoIso}
                                    icon='edit'/>
                            </Form.Field>
                                            
                        
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/paiss">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default PaisForm;